var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCamera = function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "camera_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.414 20.414A2 2 0 0 0 23 19V8a2 2 0 0 0-2-2h-4l-2-3H9L7 6H3a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h18a2 2 0 0 0 1.414-.586Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgCamera as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMjIuNDE0MiAyMC40MTQyQzIyLjc4OTMgMjAuMDM5MSAyMyAxOS41MzA0IDIzIDE5VjhDMjMgNy40Njk1NyAyMi43ODkzIDYuOTYwODYgMjIuNDE0MiA2LjU4NTc5QzIyLjAzOTEgNi4yMTA3MSAyMS41MzA0IDYgMjEgNkgxN0wxNSAzSDlMNyA2SDNDMi40Njk1NyA2IDEuOTYwODYgNi4yMTA3MSAxLjU4NTc5IDYuNTg1NzlDMS4yMTA3MSA2Ljk2MDg2IDEgNy40Njk1NyAxIDhWMTlDMSAxOS41MzA0IDEuMjEwNzEgMjAuMDM5MSAxLjU4NTc5IDIwLjQxNDJDMS45NjA4NiAyMC43ODkzIDIuNDY5NTcgMjEgMyAyMUgyMUMyMS41MzA0IDIxIDIyLjAzOTEgMjAuNzg5MyAyMi40MTQyIDIwLjQxNDJaIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48cGF0aCBkPSJNMTIgMTdDMTQuMjA5MSAxNyAxNiAxNS4yMDkxIDE2IDEzQzE2IDEwLjc5MDkgMTQuMjA5MSA5IDEyIDlDOS43OTA4NiA5IDggMTAuNzkwOSA4IDEzQzggMTUuMjA5MSA5Ljc5MDg2IDE3IDEyIDE3WiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9zdmc+";